import { formatProbability, probabilityToPercent } from '@/lib/format-probability'

interface ProbabilityProps {
  /** Stage probability as a 0–1 fraction (API contract). */
  value: number | string | null | undefined
  /**
   * `text` — right-aligned `60%` for tables.
   * `meter` — bar + percent for read-only form fields.
   */
  variant?: 'text' | 'meter'
  className?: string
}

/** Probability as a percentage; meter variant for read-only form surfaces. */
export function Probability({ value, variant = 'text', className = '' }: ProbabilityProps) {
  const label = formatProbability(value)
  const pct = probabilityToPercent(value)
  const tone =
    pct == null ? 'empty' : pct >= 100 ? 'full' : pct >= 70 ? 'high' : pct >= 40 ? 'mid' : 'low'

  if (variant === 'meter') {
    const width = pct ?? 0
    return (
      <div
        className={`probability-meter probability-meter--${tone} ${className}`.trim()}
        role="meter"
        aria-label="Probability"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct ?? undefined}
        aria-valuetext={label}
      >
        <div className="probability-meter__track" aria-hidden>
          <div className="probability-meter__fill" style={{ width: `${width}%` }} />
        </div>
        <span className="probability-meter__value">{label}</span>
      </div>
    )
  }

  return <span className={`probability ${className}`.trim()}>{label}</span>
}
